const PERMISSIONS_VOUCHER_PIN_IMPORT_PAGE = {
  VIEW: 'voucherpin_batch::get',
  CREATE: 'voucherpin_batch::create',
  GET_ALL: 'voucherpin_batch::get_all',
} as const;

export const VOUCHER_PIN_IMPORT_PERMISSIONS = [
  PERMISSIONS_VOUCHER_PIN_IMPORT_PAGE.VIEW,
  PERMISSIONS_VOUCHER_PIN_IMPORT_PAGE.CREATE,
  PERMISSIONS_VOUCHER_PIN_IMPORT_PAGE.GET_ALL,
] as const;

export default PERMISSIONS_VOUCHER_PIN_IMPORT_PAGE;
